<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle1"><a id="page_4"></a>Introduction</h2>
<p class="noindent">I was delighted to be asked by the lovely people at Search Press to design another crochet book for the <em class="italic">20 To Make</em> series; my first was on purses, but this time it was to be about flowers.</p>
<p class="indent">Flowers are wonderful projects to crochet as they are quick, decorative and make great use of all the oddments of yarn we collect. They are a wonderful way to brighten an outfit, to wear in your hair or to pin to your favourite scarf, shawl, belt or bag.</p>
<p class="indent">In this book you will find twenty different flowers to crochet. Some of them are based on real flowers, such as the Hydrangea, Snowdrop, Pansy and Lily projects; the rest are fantasy flowers, ones that were great fun for me to imagine and bring to life. I also wanted to make the flowers stand out and add a bit of depth to them, which is why some are 3D, such as the Hydrangea, Snowdrop, Lily and Spectrum. I have tried to create designs that will appeal to both beginners and more advanced crocheters.</p>
<p class="indent">All the flowers vary in size; however, by using thinner or thicker yarn and the appropriate size of crochet hook you can adjust the sizes of the flowers quite easily. In this book you will find four large flowers: Azela, Moude, Rouge and Spectrum; ten medium flowers: Aqua, Blue, Fleur, Hydrangea, Lily, Rainbow, Rosie, Roux, Snowdrop and Sorrel; and six small flowers: Pansy, Flora, Leila, Lilac, Orla and Petal.</p>
<p class="indent">I hope you enjoy making them!</p>
<div class="img_container">
<img alt="image" src="images/f0004-01.jpg"/>
</div>
<div class="img_container"><a id="page_5"></a>
<img alt="image" src="images/f0005-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Introduction.vue?1398c135